import common from './common';
import paper from 'paper';
import DrawingSpine from './drawing/DrawingSpine';
import DrawingTextureHack from './drawing/DrawingTextureHack';
import { translate } from "./utils";


export default class ComicScene extends PIXI.Container {
	constructor(comic, isFirst) {
		super();
		this.isFirst = isFirst;

		this._spines = [];
		this._comicName = comic;
		this._sceneBG = null;       // Three Scene layers, background, middleground and foreground.
		this._sceneMG = null;
		this._sceneFG = null;
		this._hasDrawnSpines = false;

		this.signals = {};
		this.signals.select = new P3.utils.MiniSignal();

		this.spriteCount = 0;

		this.popTweens = [];

		this.init();
	}

	init() {

		let comicPaper = new PIXI.Sprite(P3.assets.texture('level_select_panel'));
		comicPaper.anchor.set(0.5);
		comicPaper.position.set(common.STAGE_WIDTH * 0.5, common.STAGE_HEIGHT * 0.5);
		this.addChild(comicPaper);

		let comicPaperMask = new PIXI.Sprite(P3.assets.texture('level_select_panel'));
		comicPaperMask.anchor.set(0.5);
		comicPaperMask.position.set(common.STAGE_WIDTH * 0.5, common.STAGE_HEIGHT * 0.5);
		this.addChild(comicPaperMask);

		let mgMask = new PIXI.Graphics();
		mgMask.beginFill(0xFF0000, 0.4);
		mgMask.drawRect(-407, -303, 804, 586);
		mgMask.endFill();
		mgMask.position.set(common.STAGE_WIDTH * 0.5, common.STAGE_HEIGHT * 0.5);
		this.addChild(mgMask)

		this._sceneBG = new PIXI.Container();
		this.addChild(this._sceneBG);
		this._sceneMG = new PIXI.Container(); 
		this.addChild(this._sceneMG);
		this._sceneFG = new PIXI.Container();
		this.addChild(this._sceneFG);

		this._sceneBG.mask = comicPaperMask;
		this._sceneMG.mask = mgMask;
		this._sceneFG.mask = comicPaperMask;

		this.parseJSON(this._comicName);
	}

	createDrawingSpine(data) {
		this._data = P3.assets.json(data.texName);
		const holder = new PIXI.Container();
		data.container.addChild(holder);

		let spine = new DrawingSpine(P3.assets.spineData(this._data.spine.name), this._data.spine.name, data.texName);
		spine.scale.set(data.scale);          //this._data.spine.scale
		spine.autoUpdate = false;
		spine.stateData.defaultMix = 0.2;
		holder.addChild(spine);

		holder.position.set(data.posx, data.posy + holder.height * 0.5); 

		let hacks = common.saveData.getSpineHacks(this._data.spine.name);

		if($.isEmptyObject(hacks) || hacks === undefined) {
			hacks = false;
		} 
		
		spine.visible = this._hasDrawnSpines = hacks;

		for (let i in hacks) {
			if (hacks.hasOwnProperty(i)) {
				const t = hacks[i];
				const path = new paper.CompoundPath();
				path.importJSON(t.path);

				const slot = spine.skeleton.findSlot(i);
				const center = this.toLocal(slot.currentSprite.position, slot.currentSprite.parent);
				path.position.set(center.x + t.offset.x, center.y + t.offset.y);
				spine.addTextureHack(DrawingTextureHack.create(path, slot, center));
			}
		}
		const anim = localStorage.getItem('jerry_ear_draw') && (parseInt(localStorage.getItem('jerry_ear_draw')) > 0) ? data.finish_animation: data.animation;
		spine.state.addAnimation(0, anim, true, 0);
		spine.update(P3.Ticker.dt);

		spine.interactive = true;
		spine.buttonMode = true;
		spine.on('pointerdown', () => {
			this.onHolderClick(data.texName);
		}, this);

		this._spines.push(spine);


		return spine;
	}

	createRegularSpine(data) {
		const holder = new PIXI.Container();
		data.container.addChild(holder);

		let spine = new PIXI.spine.Spine(P3.assets.spineData(data.texName));
		spine.scale.set(data.scale);
		spine.autoUpdate = false;
		spine.stateData.defaultMix = 0.2;
		spine.update(P3.Ticker.dt);
		spine.state.setAnimation(0, 'animation', true);
		holder.position.set(data.posx, data.posy + holder.height * 0.5);

		spine.visible = data.visible;
		this._spines.push(spine);
		holder.addChild(spine);
	}

	createSprite(data) {
		let sprite = new PIXI.Sprite(P3.assets.texture(data.texName));
		sprite.scale.set(data.scale);
		sprite.anchor.set(data.anchor[0], data.anchor[1]);
		sprite.position.set(data.posx, data.posy);
		sprite.visible = data.visible;
		sprite.jsondata = data;

		if(data.spineName) {
			this._data = P3.assets.json(data.spineName);
			let hacks = common.saveData.getSpineHacks(this._data.spine.name);
			if($.isEmptyObject(hacks) || !hacks) {
				hacks = false;
			}

			sprite.visible = !hacks;
			sprite.interactive = true;
			sprite.buttonMode = true;
			sprite.on('pointerdown', () => {
				this.onHolderClick(data.spineName);
			}, this);
		}

		data.container.addChild(sprite);
	}

	destroy() {
		super.destroy({children: true});

		for (const spine of this._spines) {
			spine.destroy({children: true});
		}
		this._sceneBG.destroy({children: true});
		this._sceneMG.destroy({children: true});
		this._sceneFG.destroy({children: true});
	}

	update() {
		for (const spine of this.spines) {
			spine.update(P3.Ticker.dt);
		}
	}

	refreshSpine(oldSpine, index) {
		const json = P3.assets.json(`comic${index}`);
		const data = Object.assign({}, json.objects[oldSpine.name]);
        
		data.posx = data.pos[0];
		data.posy = data.pos[1];

		if (data.posx === 'mid') {
			data.posx = common.STAGE_WIDTH * 0.5 + data.pad[0];
		}
		if (data.posy === 'mid') {
			data.posy = common.STAGE_HEIGHT * 0.5 + data.pad[1];
		}

		if (data.container === 'background') {
			data.container = this._sceneBG;
		}
		else if (data.container === 'middleground') {
			data.container = this._sceneMG;
		}
		else if (data.container === 'foreground') {
			data.container = this._sceneFG;
		}
		data.finish_animation = data.finish_animation ? data.finish_animation : data.animation;

		common.saveData.saveSpineHacks(this._data.spine.name, this.createDrawingSpine(data));
	}

	parseJSON(file) {
		let json = null;

		try {
			json = P3.assets.json(file);
		} catch (e) {
			console.warn('Could not load JSON file: ' + file + '. It probably doesn\'t exist?');
			return;
		}

		for(let tag in json.objects) {

			let data = {};
			data.texName = json.objects[tag].texName;
			data.anchor = json.objects[tag].anchor;
			data.scale = json.objects[tag].scale;
			data.posx = json.objects[tag].pos[0];
			data.posy = json.objects[tag].pos[1];
			data.container = json.objects[tag].container;
			data.visible = json.objects[tag].visible;
			data.spineName = json.objects[tag].spineName;

			if (data.posx === 'mid') {
				data.posx = common.STAGE_WIDTH * 0.5 + json.objects[tag].pad[0];
			}
			if (data.posy === 'mid') {
				data.posy = common.STAGE_HEIGHT * 0.5 + json.objects[tag].pad[1];
			}

			if (data.container === 'background') {
				data.container = this._sceneBG;
			}
			else if (data.container === 'middleground') {
				data.container = this._sceneMG;
			}
			else if (data.container === 'foreground') {
				data.container = this._sceneFG;
			}

			if (json.objects[tag].type === 'spine') {
				data.animation = json.objects[tag].animation;
				data.finish_animation = json.objects[tag].finish_animation ? json.objects[tag].finish_animation : data.animation;
				if (json.objects[tag].excludeFromDrawing === true) {
					this.createRegularSpine(data);
				}
				else {
					this.createDrawingSpine(data);
				}

			}
			else if (json.objects[tag].type === 'sprite') {
				this.createSprite(data);
			}
		}

	}

	onHolderClick(spine) {
		common.selectedSpine = spine;
		this.signals.select.dispatch(this);
	}

	get spines() {
		return this._spines;
	}

	set spines(v) {
		this._spines = v;
	}

	get hasDrawnSpines() {
		return this._hasDrawnSpines;
	}
}